// extracted by mini-css-extract-plugin
export default {"root":"QuestionPreview_root__SDg2H","preview":"QuestionPreview_preview__rrp8u","list":"QuestionPreview_list__0okvq"};